export const NAME = 'payment';